import { useFlags } from '../feature-flags/FlagsHook';
import { MaintenanceScreen } from './MaintenanceScreen';

type Props = {
  children: React.ReactNode;
};

export function MaintenanceGate({ children }: Props) {
  const { flagEnabledMaintenanceMode } = useFlags();

  if (flagEnabledMaintenanceMode) {
    return <MaintenanceScreen />;
  }

  return <>{children}</>;
}
